//https://www.npmjs.com/package/string-mask

export default {

//	/**
//	 * 그리드 날짜 포맷
//	 */
//	$dtFmt : function $dtFmt( row ) {
//		if ( row ) {
//			var rowData = row.value;
//
//			if(rowData.length > 10) {
//				rowData = rowData.replace( /-/gi  , ''  ).substring(0,8);
//			}else{
//				rowData = rowData.replace( /-/gi  , ''  );
//			}
//			return rowData.substring( 0, 4 ) + '-' + rowData.substring( 4, 6 ) + '-' + rowData.substring( 6 );
//		} else {
//			return '';
//		}
//	},

	/**
	 * 그리드 숫자 포맷
	 */
	$numFmt( row ) {

		if( !row || !row.hasOwnProperty( 'value' ) || isNaN( row.value ) || row.value == null) return '';

    	var reg = /(^[+-]?\d+)(\d{3})/;

    	var n = (row.value + '');

    	while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');

		return n;
	},


	/**
	 * 그리드 전화번호 포맷
	 */
	$telFmt: function $telFmt( row ) {
		if(!row.value){
			return '-';
		}
		// if(row.value.length < 9){
		// 	return row.value;
		// }
		//
		// if(row.value.length === 9){
		// 	return row.value.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
		// }
		//
		// if(row.value.length === 10) {
		// 	return row.value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
		// }
		// if(row.value.length === 11) {
		// 	return row.value.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
		// }


	   return row.value.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
   },


	/**
	 * 앞뒤 공백 제거
	 */
	$removeWhiteSpace: function $removeWhiteSpace( str ) {
		if ( ! str ) {
			return str;
		} else {
			return str.replace( /^\s+/gi, '' ).replace( /\s+$/gi, '' );
		}
	},

	/**
	 * 태그 필터링
	 */
	$tagFilter : function $tagFilter( str ) {
		if ( ! str ) {
			return str;
		} else {
			return str.replace( />/ig  , '&gt;'   )
					  .replace( /</ig  , '&lt;'   )
					  .replace( /\'/gi , '&apos;' )
					  .replace( /"/gi  , '&quot;' )
				;
		}
	},

	$tagUnFilter : function $tagUnFilter( str ) {
		if ( ! str ) {
			return str;
		} else {
			return str.replace( /&gt;/gi   , '>'  )
					  .replace( /&lt;/gi   , '<'  )
					  .replace( /&apos;/gi , '\'' )
					  .replace( /&quot;/gi , '"'  )
				;
		}
	},

	/**
	 * HTML TAG 제거
	 * 사용 방법 : INPUT 태그의 change or blur 이벤트에서 사용
	 * @param htmlString
	 * @returns
	 */
	$tagRemove	:	function $tagRemove(htmlString) {
	    if(!htmlString) { return htmlString; }
	    const mydiv = document.createElement("div");
	    mydiv.innerHTML = htmlString;
	    return mydiv.textContent || mydiv.innerText || '';
	},

	/**
	 * 콤보 설정
	 *
	 * @param listItems 콤보 목록
	 * @param options   [선택] 추가 옵션
	 * 						head   상단에 추가. 'A' 전체 / 'S' 선택 / '' [없음]
	 * 						       ex) { head: 'A' }
	 * 						text   콤보 표시 명 변경. ex) { text: 'refrn1Value' }
	 * 						value  콤보 선택 값 변경. ex) { value: 'refrn2Value' }
	 */
	$getComboOptions	:	function $getComboOptions( listItems, options ) {

		//	원본 배열은 복사 해서 사용
		let cpListItems = JSON.parse( JSON.stringify( listItems ) );

		//	options 에 따라, 앞에 뭔가 변경 및 붙임... 없음 말고...
		//if ( typeof options != 'undefined' ) {

			//	콤보 표시 명 변경
			if ( options && options.hasOwnProperty( 'text'  ) ) {
				cpListItems.forEach( (x) => { x.text  = String( x[options.text ] ); } );
			} else {
				cpListItems.forEach( (x) => { x.text  = x.codeNm;    } );
			}

			//	콤보 선택 값 변경
			if ( options && options.hasOwnProperty( 'value' ) ) {
				cpListItems.forEach( (x) => { x.value = String( x[options.value] ); } );
			} else {
				cpListItems.forEach( (x) => { x.value = x.codeValue; } );
			}

			//	head 에 뭐 붙이기...
			if ( options ) {
				if ( options.head == 'A' ) {
					cpListItems.unshift( { text: '전체', value: '' } );
				} else if ( options.head == 'S' ) {
					cpListItems.unshift( { text: '선택', value: '' } );
				}
			}

		//}

		return cpListItems;;
	},

	/**
	 * 특정문자 변경하기
	 * 사용 방법 : replaceAll(orgStr, searchStr, replaceStr)
	 * @param
	 * @returns
	 */
	$replaceAll	:	function $replaceAll(orgStr, searchStr, replaceStr) {
	    return orgStr.split(searchStr).join(replaceStr);
	},


	/**
	 * null 여부 확인
	 * 사용 방법 : $isEmpty(date)
	 * @param date
	 * @returns
	 */
	$isEmpty : function $isEmpty(objValue) {
		if( objValue == undefined || objValue == null ) {
			return true;
		} else {
			return (new String(objValue)).length == 0;
		}
	},

	/*
	 * 이메일 체크
	 */
	$isEmail : function $isEmail(objValue) {

		let regExp = /^[0-9a-zA-Z_]([-_.]?[0-9a-zA-Z_])*@[0-9a-zA-Z_]([-_.]?[0-9a-zA-Z_])*.[a-zA-Z]{2,3}$/i;
		// 검증에 사용할 정규식 변수 regExp에 저장
		if (objValue.match(regExp) != null) {
		   return true;
		}else {
		  return false;
		}
	},

	/*
	 * ip 유효성 체크
	*/
	$isIp : function $isIp(objValue) {

		let regExp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
		// 검증에 사용할 정규식 변수 regExp에 저장
		if (objValue.match(regExp) != null) {
		   return true;
		}else {
		  return false;
		}

	},

	/*
	 * 전화/휴대폰 유효성 체크
	*/
	$isTelPhone : function $isIp(objValue) {

		let regExp = /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/;

		// 유효성 체크 정규식 변경
		objValue = objValue.replace(/-/gi,'');

		return objValue.match(regExp) != null

		// let regExp1 = /^\d{2,3}\d{3,4}\d{4}$/;
		// let regExp2 = /^\d{2,3}-\d{3,4}-\d{4}$/;
		//
		// // 검증에 사용할 정규식 변수 regExp에 저장
		// if (objValue.match(regExp1) != null) {
		// 	return true;
		//  }else {
		// 	 if (objValue.match(regExp2) != null) {
		// 		 return true
		// 	 }else{
		// 		 return false;
		// 	 }
		//  }

	},


	/*
	 * 사업자 등록번호 유효성 검사
	*/
	$isBizNo : function isBizNo(objValue) {
		let valueMap = objValue.replace(/-/gi,'').split('').map(function(item) {
			return parseInt(item, 10);
		})

		if ( valueMap.length === 10 ) {
			let multiply = new Array(1, 3, 7, 1, 3, 7, 1, 3, 5);
			let checkSum = 0;

			for (let i = 0; i < multiply.length; ++i) {
				checkSum += multiply[i] * valueMap[i];
			}

			checkSum += parseInt((multiply[8] * valueMap[8]) / 10, 10);
			return Math.floor(valueMap[9]) === ((10 - (checkSum % 10)) % 10);
		}

		return false;
	},


	/*
	 * 법인 등록번호 유효성 검사
	*/
	$isJurirno : function jurirno(objValue) {
		let re = /-/g;
		objValue = objValue.replace('-','');

		if (objValue.length != 13){
			return false;
		}

		let arr_regno  = objValue.split("");
		let arr_wt   = new Array(1,2,1,2,1,2,1,2,1,2,1,2);
		let iSum_regno  = 0;
		let iCheck_digit = 0;

		for (let i = 0; i < 12; i++){
			iSum_regno +=  eval(arr_regno[i]) * eval(arr_wt[i]);
		}

		iCheck_digit = 10 - (iSum_regno % 10);

		iCheck_digit = iCheck_digit % 10;

		if (iCheck_digit != arr_regno[12]){
			return false;
		}
		return true;

	},

	/*
	 * 특수문자 제거
	 */
	$setSpecialRemove : function $setSpecialRemove(objValue) {

		const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi;
	    if(regExp.test(objValue)){
	        return objValue.replace(regExp, "");
	    }else{
	    	return objValue;
	    }
	},


	$isPermitExt(ableExt, name) {

	    //확장자가 없거나(-1), 점(.)으로 시작(0) 하는 파일 차단
		if ( name.indexOf('.') < 1 ) {
			return false;
		}

		const arr = name.split('.');

		const ext = arr[ arr.length - 1 ];

		let rtn = false;

		const objArray = this.$replaceAll(this.$replaceAll(ableExt, ",", ""), " ", "").split(".");

		if(typeof objArray != 'undefined' ){
			rtn = objArray.some( (x) => { return x.toUpperCase() == ext.toUpperCase(); } )
		}

		return rtn;
	},


	/**
     * 데이터 비교
     * @desc 2개의 데이터(json, jsonArray)를 비교 후, 변경 된 부분의 값을 반환
     * @param 데이터1, 데이터2, 키이름 배열
     * ==============================================================================================================
     * 예)
     *   [[[[[[[[[[[[ 배열 데이터(jsonArray) 비교 ]]]]]]]]]]]]]]]
     *     - 데이터1                  - 데이터2               -키이름 배열
     *     [                         [                       ['a', 'b']
     *       {a:1, b:2},                {a:1, b:999},
     *       {a:3, b:4},                {a:3, b:4},
     *       {a:5, b:6},                {a:5, b:777},
     *     ]                         ]
     *
     * commonUtils.$compareDatas(데이터1, 데이터2, 키이름 배열)
     *
     * - 결과
     * [
     *    {'rowNum' : 1, 'b' : false, 'data1' : 1, 'data2': 999} <-rowNum은 1부터 시작
     * ]
     *
     * - 설명
     *   rowNum : 다른 행번호, 'b' : 다른 키 이름, 'data1': 데이터 1번 파라미터 의 값, 'data2': 데이터 2번 파라미터의 값
     *
     * ==============================================================================================================
     *
     *   [[[[[[[[[[[[ 데이터(json) 비교 ]]]]]]]]]]]]]]]
     *     - 데이터1                  - 데이터2               -키이름 배열
     *     {a:1, b:2}                 {a:1, b:999}           ['a', 'b']
     *
     * commonUtils.$compareDatas(데이터1, 데이터2, 키이름 배열)
     *
     * - 결과
     * [
     *    {'b' : false, 'data1' : 2, 'data2': 999}
     * ]
     *
     *  - 설명
     *   rowNum : 'b' : 다른 키 이름, 'data1': 데이터 1번 파라미터 의 값, 'data2': 데이터 2번 파라미터의 값
     *
     * @return 비교 항목
     */
    // 데이터 비교
    $compareDatas(obj1, obj2, keyLists) {
        const _ = require('lodash');
        let rtnValue = null;

        if(keyLists.length == undefined) {
            return 'err';
        }
		// console.log(obj1.constructor, obj2.constructor);
        if(obj1.constructor == Object && obj2.constructor == Object) {
            rtnValue = [];
            //console.log(Object.keys(obj1).length, Object.keys(obj2).length);
            // object
            // if(Object.keys(obj1).length == Object.keys(obj2).length) {

                _.forEach(keyLists, function (keyNm) {
					// console.log(keyNm, obj1[keyNm], obj2[keyNm]);
                    if(obj1[keyNm] != obj2[keyNm]) {
                        rtnValue.push({
                            [keyNm] : false,
                            'data1' : obj1[keyNm],
                            'data2' : obj2[keyNm]
                        });

                    }
                });

            // } else {
            //     return 'err';
            // }

        } else if(obj1.length == obj2.length) {
            // 비교 데이터 배열 길이 동일
            // list
            rtnValue = [];

            // if(Object.keys(obj1[0]).length == Object.keys(obj2[0]).length) {
                _.forEach(obj1, function(row, index) {
                    _.forEach(keyLists, function (keyNm) {
                        if(obj1[index][keyNm] != obj2[index][keyNm]) {
                            rtnValue.push({
                                rowNum:(index + 1),
                                [keyNm]: false,
                                'data1' : obj1[index][keyNm],
                                'data2' : obj2[index][keyNm]
                            });
                        }
                    });
                });

            // } else {
            //     return 'err';
            // }

        } else {
            // 비교 데이터 배열 길이 같지 않음
            // list
            rtnValue = [];
            //console.log(obj1, obj2);
            const sizeCalc = obj1.length - obj2.length;

            let standardNum = obj2.length;

            if(sizeCalc < 0) {
                sizeCalc = sizeCalc * -1;
                standardNum = obj1.length;
            }

            _.forEach(sizeCalc, function(row, index) {
                rtnValue.push({
                    rowNum:(standardNum + index + 1)
                });
            });
        }

        return rtnValue;
		},

		// $compareDatas 비교함수는 현재 array 경우 주소값이 다르기 때문에 무조건 false 로 나와서 배열비교 하고있어서 배열비교 함수 추가
		$compareArray(arr1, arr2) {

			// 결과값
			let rst = false;

			// 길이가 다르면 다른 배열이라고 판단
			if (arr1.length != arr2.length) {
					return rst;
			}

			// arr1 배열의 크기만큼 반복
			arr1.forEach(function (item) {

					// arr1 배열 아이템이, arr2 배열에 있는지 확인
					// 있으면, arr2에 item이 존재하는 index 리턴
					// 없으면, -1 리턴
					let i = arr2.indexOf(item);

					// 존재하면, splice함수를 이용해서 arr2 배열에서 item 삭제
					if (i > -1) arr2.splice(i, 1);
			});

			// compare2의 길이가 0이면 동일하다고 판단.
			rst = arr2.length == 0;

			return rst;
		},

	/**
	 * window.open() 으로 팝업창의 띄울때
	 * 팝업창이 화면 중앙에 위치 하도록 함...
	 */
	$getPopupStyle ( w, h ) {	//console.log( w, h );

		let style = 'resizable=no,modal=yes';

//		const sw = window.screen.width;
//		const sh = window.screen.height;
		const sw = document.body.clientWidth;	//	현재창의 너비
		const sh = document.body.clientHeight;	//	현재창의 높이

		//console.log( sw, sh );

		const wl = window.screenX || window.screenLeft || 0;	//	현재창의 x좌표
		const wt = window.screenY || window.screenTop  || 0;	//	현재창의 y좌표

		//console.log( wl, wt );

		let pl = ( sw - w ) / 2 + wl;
		let pt = ( sh - h ) / 2 + wt;
//		let pl = ( wl - w ) / 2;
//		let pt = ( wt - h ) / 2 - 100;	//	살~짝 위로... ^^;

		//console.log( pl, pt );

		style += ',left=' + pl + ',top=' + pt + ',width=' + w + ',height=' + h;

		//console.log( style );

		return style;
	},

	/**
	 * 로그인 화면에서 window.open() 으로 팝업창의 띄울때
	 * 팝업창이 화면 중앙에 위치 하도록 함...
	 */
	 $getNsPopupStyle ( w, h ) {	//console.log( w, h );

		let style = 'resizable=no,modal=yes';

//		const sw = window.screen.width;
//		const sh = window.screen.height;
		const sw = window.innerWidth;	//	현재창의 너비
		const sh = window.innerHeight;	//	현재창의 높이

		//console.log( sw, sh );

		const wl = window.screenX || window.screenLeft || 0;	//	현재창의 x좌표
		const wt = window.screenY || window.screenTop  || 0;	//	현재창의 y좌표

		//console.log( wl, wt );

		let pl = ( sw - w ) / 2 + wl;
		let pt = ( sh - h ) / 2 + wt;
//		let pl = ( wl - w ) / 2;
//		let pt = ( wt - h ) / 2 - 100;	//	살~짝 위로... ^^;

		//console.log( pl, pt );

		style += ',left=' + pl + ',top=' + pt + ',width=' + w + ',height=' + h;

		//console.log( style );

		return style;
	},


	/**
	 * 언어별 상세리스트 저장형 데이터의 템플릿 생성
	 * @param {*} sys003CmmnCodeList 언어공통코드목록[SYS003]
	 * @param {*} detailTemplate 생성할 상세항목의 템플릿(기본형)
	 * @param {*} keyCode 상세항목에 언어코드로 설정할 대상키
	 */
	$getDetailArrayByLangTycode(sys003CmmnCodeList, detailTemplate, keyCode) {
		// console.log("$getDetailArrayByLangTycode$getDetailArrayByLangTycode$getDetailArrayByLangTycode$getDetailArrayByLangTycode");
		const detailList = [];
		for(const v in sys003CmmnCodeList) {
			const detailItem = Object.assign({}, detailTemplate);
			detailItem[keyCode] = sys003CmmnCodeList[v].codeValue;
			detailList.push(detailItem);
		}
		return detailList;
	},


	/**
	 * 버전 비교
	 */
	$compareVersions(currVer, targetVer) {
		const currVerArr = currVer.split('.').map(Number);
		const targetVerArr = targetVer.split('.').map(Number);
		const maxLength = Math.max(currVerArr.length, targetVerArr.length);

		for (let i = 0; i < maxLength; i++) {
			const curr = currVerArr[i] || 0;
			const target = targetVerArr[i] || 0;

			if (curr > target) return true;
			if (curr < target) return false;
		}

		return true;
	}
}
